<i18n lang="yaml" locale="en">
  deactivate smooth slider to import slides: Please deactivate the smooth slider to be able to import slides.
  imported modals: No modals to import. | One modal imported. | {count} modals imported.
  imported slides: No slides to import. | One slide imported. | {count} slides imported.
  not a project: This file seems broken. Import stopped.
</i18n>

<i18n lang="yaml" locale="de">
  deactivate smooth slider to import slides: Bitte deaktivieren Sie die stufenlose Seite um weitere Seiten zu importieren.
  imported modals: Keine modales Fenster zu importieren. | Ein modales Fenster importiert. | {count} modale Fenster importiert.
  imported slides: Keine Seiten zu importieren. | Eine Seite importiert. | {count} Seiten importiert.
  not a project: Die Datei scheint defekt zu sein. Import abgebrochen.
</i18n>

<template>
  <tw-file-input
    :accepted="['application/json']"
    @read="onFileRead"
    read-as="text"
  >
    <save
      size="xs"
    />
  </tw-file-input>
</template>

<script>
import Save from '@/components/icons/Save'
import TwFileInput from '@/components/ui/TwFileInput'
import { Error, Success, Warning } from '@/plugins/snotify'

export default {
  name: 'ImportExport',
  components: {
    Save,
    TwFileInput
  },
  computed: {
    $modals () {
      return this.$store && this.$store.getters.childrenByName.modals
    },
    $slider () {
      return this.$store && this.$store.getters.childrenByName.slider
    },
    $smoothSlider () {
      return this.$store && this.$store.getters.childrenByName.smoothSlider
    }
  },
  methods: {
    async onFileRead (data) {
      const nameMap = {}
      if (data._type !== 'project') {
        return new Error(this.$t('not a project')).open()
      }

      const hasModals = data.modals && data.modals._children.length > 0
      const hasSlides = data.slider && data.slider._children.length > 0

      if (hasModals) {
        if (!this.$modals) {
          this.$store.dispatch('addChild', {
            childType: 'modalController',
            name: 'modals'
          })
        }
        const count = await this.importChildren(data.modals, '/modals', nameMap)
        new Success(this.$tc('imported modals', count, { count })).open()
      } else {
        new Warning(this.$tc('imported modals', 0)).open()
      }

      if (hasSlides) {
        if (this.$smoothSlider) {
          new Warning(this.$t('deactivate smooth slider to import slides')).open()
        } else {
          if (!this.$slider) {
            this.$store.dispatch('addChild', {
              childType: 'slider',
              name: 'slider'
            })
            this.$router.push({ path: this.$slider.getters.path })
          }
          const count = await this.importChildren(data.slider, '/slider', nameMap)
          new Success(this.$tc('imported slides', count, { count })).open()
        }
      } else {
        new Warning(this.$tc('imported slides', 0)).open()
      }

      if (hasModals) {
        this.replaceLinks('/modals', nameMap)
      }
      if (hasSlides) {
        this.replaceLinks('/slider', nameMap)
      }
    },
    async importChildren (parent, parentPath, nameMap) {
      if (!nameMap[parentPath]) {
        nameMap[parentPath] = {}
      }
      for (const child of parent._children) {
        nameMap[parentPath][child] = await this.$store.getters.modulesByPath[parentPath].dispatch('importChild', { child: parent[child] })
      }
      return parent._children.length
    },
    replaceLinks (parentPath, nameMap) {
      const parseChildren = (path, checkImported = false) => {
        for (const child of this.$store.getters.modulesByPath[path].getters.children) {
          if (checkImported && !Object.values(nameMap[parentPath]).includes(child.getters.name)) {
            continue
          }
          const checkProps = (props, locale) => {
            if (props.link) {
              const linkPath = props.link.split('/')
              const newName = nameMap['/' + linkPath[1]][linkPath[2]]
              if (newName) {
                linkPath[2] = newName
                child.commit('setProp', { key: 'link', value: linkPath.join('/'), locale })
              } else {
                child.commit('setProp', { key: 'link', value: undefined, locale })
              }
            }
          }
          checkProps(child.state._props, '')
          for (const locale in child.state._props_locales) {
            checkProps(child.state._props_locales[locale], locale)
          }
          parseChildren(child.getters.path)
        }
      }
      parseChildren(parentPath, true)
    }
  }
}
</script>

<style scoped lang="scss">
span {
  display: flex;
  margin-left: auto;
  margin-right: 8px;
}
</style>
